import React from 'react';
import { X } from 'lucide-react';
import VersionHistoryPanel from './VersionHistoryPanel';
import type { GameVersion } from '../../types/api';
import type { VersionAction } from './VersionListItem';

interface VersionHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectId: string;
  projectName: string;
  versions: GameVersion[];
  isLoading: boolean;
  error: string | null;
  onActionSelect: (action: VersionAction, version: GameVersion) => void;
  onRefresh?: () => void;
}

const VersionHistoryModal: React.FC<VersionHistoryModalProps> = ({
  isOpen,
  onClose,
  projectId,
  projectName,
  versions,
  isLoading,
  error,
  onActionSelect,
  onRefresh
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white dark:bg-dark-card rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
            <div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-dark-text">
                Version Management
              </h2>
              <p className="text-sm text-gray-500 dark:text-dark-text-muted mt-1">
                {projectName}
              </p>
            </div>
            
            <button
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
            </button>
          </div>
          
          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(90vh-120px)]">
            <VersionHistoryPanel
              projectId={projectId}
              versions={versions}
              isLoading={isLoading}
              error={error}
              onActionSelect={onActionSelect}
              onRefresh={onRefresh}
              className="border-0 shadow-none bg-transparent"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionHistoryModal; 